import CallQualityFeedback from './CallQualityFeedback'
import * as styles from './CallQualityWizardIssueStep.css'
import type { CallQualityWizardStepProps } from './types'

type CallQualityWizardIssueStepProps = CallQualityWizardStepProps

export default function CallQualityWizardIssueStep({
  children,
  onClose,
}: CallQualityWizardIssueStepProps) {
  return (
    <CallQualityFeedback onClose={onClose}>
      <CallQualityFeedback.Header
        title="Sorry to hear that"
        subtitle="What was the main issue?"
      />
      <CallQualityFeedback.Content className={styles.content}>
        {children}
      </CallQualityFeedback.Content>
    </CallQualityFeedback>
  )
}
